/**
 * Type của màn lập dự toán chi thương xuyên
 */
export default {
    TitleB: 2,
    Field: 5,
    Chapter: 10,
    SubKind: 15,
    Source: 20,
    Criteria: 25,
    Regular: 30,
    Invest: 35,
};
